import { reportClient } from '../../api/clients';
import getScanHistory from './get-scan-history/get-scan-history.service';
const scanHistoryService = {
  getScanHistoryData: getScanHistory(reportClient),
};

export default scanHistoryService;
